// extracted by mini-css-extract-plugin
export default {"paging":"paging_paging__8IlHC"};